import React, { useEffect, useRef, useState } from 'react';

const CTABanner = ({ onBooking }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="cta"
      ref={sectionRef}
      className="relative py-28 px-6 text-center overflow-hidden border-t border-b border-white/5"
      style={{ background: 'linear-gradient(135deg, #020617 0%, #0a0e1a 50%, #020617 100%)' }}
    >
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .cta-animate {
          opacity: 0;
        }
        .cta-animate.visible {
          animation: fadeInUp 0.7s ease-out forwards;
        }
      `}</style>

      {/* Background glow */}
<div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[300px] bg-[#007bff]/8 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-3xl mx-auto relative z-10">
        <p
          className={`cta-animate ${isVisible ? 'visible' : ''} text-xs font-bold uppercase tracking-[0.2em] text-[#007bff] mb-4`}
        >
          Predictable Revenue Starts Here
        </p>

        <h2
          className={`cta-animate ${isVisible ? 'visible' : ''} text-3xl md:text-5xl font-extrabold text-white tracking-tight leading-tight mb-4`}
          style={isVisible ? { animationDelay: '0.1s' } : {}}
        >
          Ready to Install an End-to-End{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0099ff] to-[#00ccff]">
            Growth System
          </span>{' '}
          Into Your Business?
        </h2>

        <p
          className={`cta-animate ${isVisible ? 'visible' : ''} text-gray-400 text-lg mb-10 max-w-xl mx-auto`}
          style={isVisible ? { animationDelay: '0.2s' } : {}}
        >
          Let's talk about what a custom lead generation and automation system could do for
          your revenue in 90 days.
        </p>

        <button
          onClick={onBooking}
          className={`cta-animate ${isVisible ? 'visible' : ''} bg-[#007bff] text-white font-black px-12 py-5 rounded-2xl text-lg glow-button inline-block`}
          style={isVisible ? { animationDelay: '0.3s' } : {}}
        >
          Book Your Free Strategy Call →
        </button>
      </div>
    </section>
  );
};

export default CTABanner;
